var $aa36476f91664a08$exports = {};
$aa36476f91664a08$exports = {
    "(required)": `(required)`,
    "(optional)": `(optional)`
};


export {$aa36476f91664a08$exports as default};
//# sourceMappingURL=en-US.module.js.map
